import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { notification, modal, logError } from 'redux/modules/app'
import { tasks as tasksApi } from 'redux/modules/api'
import { areAllSelectedForBulk, mapInvitedParticipantsForBulk } from 'redux/selectors/tasks/tasksInvitedParticipants'


function decorator(config = {}) {
  return ComposedComponent => {
    const enhance = compose(
      connect(
        state => ({
          local: {
            user: state.auth.user,
            activeOrganizationId: state.auth.organization.id,
          },
          tasks: state.api.tasks.invitedParticipants,
          selectableInvitedParticipantsIds: mapInvitedParticipantsForBulk(state),
          areAllInvitedParticipantsSelected: areAllSelectedForBulk(state),
          commonLimit: state.app.commonLimit
        }),
        {
          ...tasksApi.invitedParticipants,
          notification,
          modal,
          logError,
          bulkSelectInvitedParticipants: tasksApi.invitedParticipants.toggleTasksInvitedParticipantsAllSelected,
          getTasksOverview: tasksApi.overview.getTasksOverview
        }
      )
    )

    class TasksInvitedParticipants extends Component {
      static propTypes = {
        tasks: PropTypes.object.isRequired,
        decoFilter: PropTypes.string,
        commonLimit: PropTypes.number,
        notification: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        modal: PropTypes.func.isRequired,
        setTasksInvitedParticipantsParams: PropTypes.func.isRequired,
        getTasksInvitedParticipants: PropTypes.func.isRequired,
        setTasksInvitedParticipantsSelected: PropTypes.func,
        deleteInvitedParticipant: PropTypes.func.isRequired,
        resendInvitationEmail: PropTypes.func.isRequired,
        getTasksOverview: PropTypes.func.isRequired,
        local: PropTypes.object.isRequired
      }

      componentDidMount() {
        const { commonLimit, setTasksInvitedParticipantsParams } = this.props

        let { tasks } = this.props

        if (config.useCommonLimit && commonLimit) {
          tasks = {
            ...tasks,
            limit: commonLimit
          }

          setTasksInvitedParticipantsParams({ limit: commonLimit })
        }

        config.list && this.handleGetTasksInvitedParticipants(tasks, this.handleGetBaseFilter())
      }

      componentWillReceiveProps(nextProps) {
        const { tasks } = this.props
        const { filter, limit, offset, sort } = nextProps.tasks

        if (
          tasks.filter !== filter ||
          tasks.limit !== limit ||
          tasks.offset !== offset ||
          tasks.sort !== sort
        ) {
          config.list && this.handleGetTasksInvitedParticipants(nextProps.tasks, this.handleGetBaseFilter())
        }
      }

      handleGetBaseFilter = () => {
        return ''
      }

      handleGetTasksInvitedParticipants = (tasks, baseFilter) => {
        return this.props.getTasksInvitedParticipants(tasks, baseFilter)
      }

      handleSetInvitedParticipantsSelectedTo = (participantRegistrationId, taskId, newVal) => {
        const selected = this.props.tasks.selectedIds || []
        const filtered = selected.filter(item => item.participantRegistrationId !== participantRegistrationId)

        const updated = newVal
          ? [...filtered, { participantRegistrationId, taskId }]
          : filtered

        this.props.setTasksInvitedParticipantsSelected(updated)
      }

      handleDeleteInvitedParticipant = taskId => {
        this.props.deleteInvitedParticipant(taskId)
          .then(this.handleDeleteSuccess)
          .catch(this.handleError)
      }

      handleDeleteSuccess = () => {
        this.props.notification('Invited participant has been deleted', {
          status: 'success',
          intlKey: 'notifications.invited_participant_has_been_deleted'
        })
        this.props.modal(null)
        this.handleRefresh()
      }

      handleResendInvitationEmail = participantRegistrationId => {
        this.props.resendInvitationEmail(participantRegistrationId)
          .then(this.handleResendSuccess)
          .catch(this.handleError)
      }

      handleResendSuccess = () => {
        this.props.notification('Invitation email has been resent', {
          status: 'success',
          intlKey: 'notifications.invitation_email_has_been_resent'
        })
        this.props.modal(null)
      }

      handleError = err => {
        console.log('error', err.body && err.body.userMessage)
        this.props.logError(err)
      }

      handleRefresh = () => {
        const { tasks } = this.props

        if (config.updateTasks) {
          this.handleGetTasksInvitedParticipants(tasks, this.handleGetBaseFilter())
          this.props.getTasksOverview(null, {
            orgId: null,
            activeOrganizationId: this.props.local.activeOrganizationId,
            awardLeaderId: this.props.local.user.personId
          })
        }
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            setInvitedParticipantsSelectedTo={this.handleSetInvitedParticipantsSelectedTo}
            deleteInvitedParticipant={this.handleDeleteInvitedParticipant}
            resendInvitationEmail={this.handleResendInvitationEmail}
          />
        )
      }
    }

    return enhance(TasksInvitedParticipants)
  }
}

export default decorator
